import { render } from "./PreferenceModal.vue?vue&type=template&id=89cb47f2&scoped=true"
import script from "./PreferenceModal.vue?vue&type=script&lang=js"
export * from "./PreferenceModal.vue?vue&type=script&lang=js"

import "./PreferenceModal.vue?vue&type=style&index=0&id=89cb47f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89cb47f2"]])

export default __exports__